import { render, staticRenderFns } from "./ModalCadastraFuncoes.vue?vue&type=template&id=2a488c91"
import script from "./ModalCadastraFuncoes.vue?vue&type=script&lang=js"
export * from "./ModalCadastraFuncoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports